<template>
  <dn-tooltip
    v-if="copyright.tooltipHtml"
    class="dn-copyright"
    :tooltip-text="copyright.tooltipHtml"
  >
    <atlas-link
      :to="copyright.pageLink"
      :title="copyright.label"
      :href="copyright.pageLink"
      :aria="copyright.linkAlt"
      external
    />
  </dn-tooltip>
  <atlas-link
    v-else
    :to="copyright.pageLink"
    :title="copyright.label"
    :href="copyright.pageLink"
    :aria="copyright.linkAlt"
    external
  />
</template>

<script setup lang="ts">
import { AtlasLink } from '@nhst/ui';
defineProps({
  copyright: {
    type: Object,
    required: true
  }
});
</script>

<style lang="scss">
.dn-copyright {
  --atlas-link_display: block;
  --atlas-link_font-size: var(--typography-utility-s-font-size);
  --atlas-link_font-family: var(--typography-utility-s-font-family);
  --atlas-link_font-weight: var(--typography-utility-s-font-weight);
  --atlas-link_line-height: var(--typography-utility-s-line-height);
  --atlas-link_letter-spacing: var(--typography-utility-s-letter-spacing);
}
</style>
